import { AfterViewInit, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  title = 'Knupu Reader';
  public version: string = packageJson.version;

  ngAfterViewInit(): void {
    console.log(environment.env);
    console.log(this.version);
  }
}
